import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Pipes
import { FilterPipe } from './filter/filter.pipe';

@NgModule({
  imports: [CommonModule, IonicModule, RouterModule, FormsModule],
  declarations: [FilterPipe],
  exports: [FilterPipe],
})
export class PipesModule {}
